import React from "react";
import { Chip, styled } from "@mui/material";

const StyledRoot = styled(Chip)(({status, size}) => ({
  fontSize: "12px",
  height: "auto",
  paddingTop: "2px",
  paddingBottom: "2px",

  ...((size === "small") && ({
    fontSize: "9px"
  })),
  ...((size === "large") && ({
    fontSize: "16px"
  })),
  ...((status === 1 || status === 7) && ({
    color: "#ffffff",
    backgroundColor: "rgb(238, 187, 0)"
  })),
  ...((status === 2 || status === 5) && ({
    color: "#ffffff",
    // backgroundColor: "#5beec0"
    // backgroundColor: "#30B98F"
    backgroundColor: "#6FDFBD"
  })),
  ...((status === 3 || status === 6)&& ({
    color: "#ffffff",
    // backgroundColor: "#ff3838"
    backgroundColor: "#E46A76"
  })),
}))

const ChipStatus = (props) => {

  const { status, size } = props;

  const getLabel = () => {
    switch(status){
      case 1: return "รออนุมัติ";
      case 2: return "อนุมัติ";
      case 3: return "ไม่อนุมัติ";
      case 4: return "ดำเนินการ";
      case 5: return "สำเร็จ";
      case 6: return "ไม่สำเร็จ";
      case 7: return "รอประเมินผล";
      default: return "";
    }
  }

  //1. Pending
  //2. Approved
  //3. Rejected
  //4. In Progress
  //5. Achieved
  //5. Not achieved
  
  return (
   <StyledRoot label={getLabel()} status={status} size={size}/>
  )
}

export default ChipStatus